import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: "IT",
};

export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});

export const selectLanguage = (state) => state.language.language;
export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
